import { css, withBem } from "../../sitches.config";

export const styles = withBem("accordion-list", {
  accordionList: css({}),
  wrapper: css({
    borderBottom: "1px solid $iron"
  })
});
